//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import Swal from "sweetalert2";

export default {
    name: "Litigationcourtcasetype",
    data() {
        return {
            search: "",
            loading: false,
            saving: false,
            deleting: false,

            items: [],

            dialog: false,
            dialogDelete: false,
            isEdit: false,
            formValid: false,

            editItem: { id: null, name: "" },
            defaultItem: { id: null, name: "" },

            rules: {
                required: (v) => !!v || "จำเป็นต้องกรอก",
            },

            // authorize
            userId: null,
            authorize_id: null,
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,
        };
    },

    computed: {
        filteredItems() {
            if (!this.search) return this.items;
            const kw = this.search.toLowerCase();
            return this.items.filter(
                (i) => i.name && i.name.toLowerCase().includes(kw)
            );
        },
    },

    async beforeCreate() {
        this.$store.state.navMenu = true;
    },

    async mounted() {

        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            // ----------------- Check Authorize ID ---------------------------
            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            // ----------------- Resolve Current Route Path -------------------
            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.replace("/", "");

            // ----------------- Fetch Authorization --------------------------
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            // ----------------- Check Login Status ---------------------------
            if (this.userId && api.isLoggedIn()) {
                await this.loadData();
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
            }
        } catch (error) {
            console.error("mounted() error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        } finally {
            this.$hideLoader();
        }
    },

    methods: {
        // ----------------- Load list -----------------
        async loadData() {
            this.loading = true;
            try {
                const res = await api.dispute_resolution_getall_courttype();
                this.items = res.data || [];
            } catch (error) {
                console.error("loadData() error:", error);
            } finally {
                this.loading = false;
            }
        },

        formatDate(d) {
            if (!d) return "—";
            const date = new Date(d);
            if (isNaN(date)) return "—";
            return date.toLocaleDateString("th-TH", {
                year: "numeric",
                month: "short",
                day: "numeric",
            });
        },

        // ----------------- Open dialogs -----------------
        openCreate() {
            this.isEdit = false;
            this.editItem = Object.assign({}, this.defaultItem);
            this.dialog = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        openEdit(item) {
            this.isEdit = true;
            this.editItem = Object.assign({}, item);
            this.dialog = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        openDelete(item) {
            this.editItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        closeDialog() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editItem = Object.assign({}, this.defaultItem);
            });
        },

        isDuplicateName(name, excludeId = null) {
            const normalized = (name || "").trim().toLowerCase();
            if (!normalized) return false;
            return this.items.some(
                (i) =>
                    i.name &&
                    i.name.trim().toLowerCase() === normalized &&
                    i.id !== excludeId
            );
        },

        // ----------------- Save (create / update) -----------------
        async onSave() {
            if (!this.$refs.form.validate()) return;
            const isDup = this.isDuplicateName(
                this.editItem.name,
                this.isEdit ? this.editItem.id : null
            );
            if (isDup) {
                Swal.fire({
                    icon: "warning",
                    title: "ชื่อศาลซ้ำ",
                    text: "มีชื่อศาลนี้อยู่ในระบบแล้ว กรุณาใช้ชื่ออื่น",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return;
            }
            this.saving = true;
            try {
                await this.$showLoader()
                if (this.isEdit) {
                    var datalist = {
                        name: this.editItem.name,
                        user_update: localStorage.getItem(server.USER_ID),
                    }
                    await api.dispute_resolution_update_courttype(this.editItem.id, datalist);
                } else {
                    var datalist = {
                        name: this.editItem.name,
                        user_create: localStorage.getItem(server.USER_ID),
                        user_update: localStorage.getItem(server.USER_ID),
                    }
                    await api.dispute_resolution_add_courttype(datalist)
                }

                this.closeDialog();
                await this.loadData();

                Swal.fire({
                    icon: "success",
                    title: this.isEdit ? "แก้ไขสำเร็จ" : "เพิ่มสำเร็จ",
                    text: this.isEdit ? "บันทึกการแก้ไขเรียบร้อยแล้ว" : "เพิ่มประเภทคดีใหม่เรียบร้อยแล้ว",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });

            } catch (error) {
                console.error("onSave() error:", error);
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            } finally {
                await this.$hideLoader()
                this.saving = false;
            }
        },

        // ----------------- Delete -----------------
        async onDelete() {
            await this.$showLoader()
            this.deleting = true;
            try {
                await api.dispute_resolution_delete_courttype(this.editItem.id);
                this.dialogDelete = false;
                await this.loadData();

                Swal.fire({
                    icon: "success",
                    title: "ลบสำเร็จ",
                    text: "ลบข้อมูลประเภทคดีเรียบร้อยแล้ว",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });

            } catch (error) {
                console.error("onDelete() error:", error);
                Swal.fire({
                    icon: "error",
                    title: "ลบไม่สำเร็จ",
                    text: "ไม่สามารถลบข้อมูลได้ อาจมีคดีที่อ้างถึงประเภทคดีนี้อยู่",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            } finally {
                await this.$hideLoader()
                this.deleting = false;
            }
        },
    },
};
